import component from './component'
import EnhanceGlobalErrorBoundary from './enhancers/EnhanceGlobalErrorBoundary'

export default EnhanceGlobalErrorBoundary(component)
